import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import AddProduct from '../product/AddProduct';


export default function ContentHeader(props) {
    const { t } = useTranslation();
    const breadcrumb = { border: "none", float: "right" };

    const [productModal, setProductModal] = useState(false);

    const renderNewButton = () => {
        if (props.newButton && props.newButtonLink) {
            if (props.modal) {
                return (
                    <Button className='btn btn-sm btn-primary ml-2' onClick={(e) => openModal(props.modalName)} >
                        {t(props.newButton)}
                    </Button>
                );
            } else {
                return (
                    <Link className='btn btn-sm btn-primary ml-2' to={`/${props.newButtonLink}`}>
                        {t(props.newButton)} {/* Translate the button label */}
                    </Link>
                );
            }
        }
        return null;
    };

    const openModal = (modalName) => {
        if (modalName === 'product') {
            setProductModal(true);
        }
    };

    const closeModal = (modalName, data = {}) => {
        if (modalName === 'product') {
            setProductModal(false);
            if (Object.keys(data).length > 0) {
                if (data.status === 'RESULT_OK') {
                    if (props.refreshData) {
                        props.refreshData();
                    }
                }
            }
        }
    };


    return (
        <>
            <section className="content-header slide-in">
                <div className="w-100">
                    <div className="row ">
                        <div className="col-sm-6 demoClass">
                            <h3 className='font-weight-bold'>
                                {t(props.title)}
                                {renderNewButton()}
                            </h3>
                        </div>
                        <div className="col-sm-6 d-flex justify-content-end">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb" style={breadcrumb}>
                                    <li className="breadcrumb-item">
                                        <Link to={"/root"}>{t('dashboard')}</Link>
                                    </li>
                                    {props.subTitle && props.subTitleLink && (
                                        <li className="breadcrumb-item">
                                            <Link to={`/${props.subTitleLink}`}>{t(props.subTitle)}</Link>
                                        </li>
                                    )}
                                    <li className="breadcrumb-item active" aria-current="page">
                                        {t(props.title)}
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
                <AddProduct show={productModal} handleClose={closeModal} />
            </section>
        </>
    );
}
